module.exports = __webpack_public_path__ + "static/media/howitworks_bg_sm.318826dd.jpg";